export default "__VITE_ASSET__Dwu2oJpC__"